import React, { useEffect, useState } from 'react';
import { Card, CardMedia, CardContent, CardActions, Avatar, IconButton, Typography, Grid, Box, Menu, MenuItem } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import StarIcon from '@mui/icons-material/Star';
import { AppBar, Toolbar, Divider } from '@mui/material';
import NoDataImg from '../../../assets/img/no-data.gif'
import CloseIcon from '@mui/icons-material/Close';
import FavoriteIcon from '@mui/icons-material/Favorite';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@mui/material/Button'
import { uplodateLoading } from '../../../redux/features/common/commonSlice';
import { showDangerToast, showToast } from '../../constants/toaster';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ChatIcon from '@mui/icons-material/Chat';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { TransferToPromoModal } from './TransferToPromoModal';



const VideoCard = ({ id, totalViews, totalLikes, totalComments, userId, userName, userProfile, thumbnail, url, alreadyRewarded, eventId, postions, handleTransferToPromoModalOpen, eventDetails, onClick, style,
    handlePlay, handlePause }) => {
    const userData = useSelector(state => state?.userData)
    const dispatch = useDispatch()
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        console.log("=================33333333333333333============", eventDetails?.selectedVideosWinnerList)
    }, [])

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleAdd = async (pos) => {
        try {
            // Prepare the JSON data to be sent in the POST request
            let postJson = {
                eventId: eventId,
                videoId: id,
                position: pos,
            };
            // Set loading state
            dispatch(uplodateLoading(true));

            // Define the API path
            let path = urls.setWinnerByAdmin;

            // Make the POST request
            var res = await ApiCaller.post(postJson, path, userData?.access_token);

            // Handle the response
            const response = await res.response.json();
            if (response.status === '200') {
                dispatch(uplodateLoading(false));
                showToast(response?.message);
            } else {
                dispatch(uplodateLoading(false));
                showDangerToast(response.message);
            }
        } catch (error) {
            dispatch(uplodateLoading(false));
            console.error(error);
            showDangerToast(error.message);
        }
        handleMenuClose();
    };

    return (
        <Card sx={{ width: '100%', position: 'relative', margin: '0 auto' }} onClick={(e) => onClick(e)} style={style}>
            {/* Cross Strip with "Selected" Label */}
            {eventDetails?.selectedVideosWinnerList?.some((item) => item?.video?.id === id)
                ? <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '100%', // Adjust width for better visibility
                        height: '16px',
                        backgroundColor: '#ff5722', // Custom color for the strip
                        color: '#fff',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        transformOrigin: 'top right',
                        fontSize: '12px',
                        zIndex: 2,
                        fontWeight: 'bold',
                    }}
                >
                    Selected
                </Box> : <></>}

            <Box sx={{ position: 'relative' }}>
                <CardMedia
                    component="img"
                    height="200"
                    image={thumbnail}
                    alt="Video Thumbnail"
                    onError={(e) => {
                        e.target.onerror = null; // Prevents infinite loop
                        e.target.src =
                            'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'; // Fallback image URL
                    }}
                />
                {/* Play button overlay */}
                <IconButton
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        },
                    }}
                    aria-label="play video"
                >
                    <PlayArrowIcon fontSize="large" onClick={() => handlePlay(url)} />
                </IconButton>

                {!eventDetails?.resultAnnounced && postions?.length > 0 ? (
                    <>
                        <IconButton
                            aria-label="settings"
                            onClick={handleMenuOpen}
                            sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                color: 'rgba(255, 255, 255, 0.7)',
                            }}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                        >
                            {postions?.map((data) => {
                                return (
                                    <MenuItem onClick={() => handleAdd(data?.position)}>
                                        Mark as {data?.position}
                                    </MenuItem>
                                );
                            })}
                            <MenuItem
                                onClick={() => {
                                    handleMenuClose();
                                    handleTransferToPromoModalOpen(url);
                                }}
                            >
                                Transfer To Promo
                            </MenuItem>
                        </Menu>
                    </>
                ) : (
                    <></>
                )}
            </Box>
            <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                <Avatar sx={{ mr: 1 }} src={userProfile || undefined}>
                    {!userProfile && userName.charAt(0).toUpperCase()}
                </Avatar>
                <Typography variant="subtitle2">{userName}</Typography>
            </CardContent>
            <CardActions>
                <IconButton aria-label="add to favorites">
                    <FavoriteIcon />
                </IconButton>
                <Typography variant="caption">{totalLikes}</Typography>
                <IconButton aria-label="star">
                    <VisibilityIcon />
                </IconButton>
                <Typography variant="caption">{totalViews}</Typography>
                <IconButton aria-label="star">
                    <ChatIcon />
                </IconButton>
                <Typography variant="caption">{totalComments}</Typography>
            </CardActions>
        </Card>


    );
};

export const EventSubmissionVideosList = (props) => {
    const [selectedIds, setSelectedIds] = useState([]);
    const dispatch = useDispatch()
    const LOADING_ENABLE = useSelector((state) => state?.loading);
    const userData = useSelector(state => state?.userData)
    const [showTransferToPromoModal, setShowTransferToPromoModal] = useState(false)
    const [transferVideoLink, setTransferVideoLink] = useState('')

    const [videos, setVideos] = useState([])

    useEffect(() => {
        getTotalParticipantsList()
    }, [])

    const handleTransferToPromoModalOpen = (link) => {
        setShowTransferToPromoModal(!showTransferToPromoModal)
        setTransferVideoLink(link)
    }

    const getTotalParticipantsList = async () => {
        try {
            // Prepare the JSON data to be sent in the POST request
            let postJson = {
                searchText: '',
                sort: 'createdAt',
                order: true,
                page: 0,
                limit: 10,
                eventId: props?.id
            };
            // Set loading state
            dispatch(uplodateLoading(true));

            // Define the API path
            let path = urls.totalParticipantsList;

            // Make the POST request
            var res = await ApiCaller.post(postJson, path, userData?.access_token);

            // Handle the response
            const response = await res.response.json();
            dispatch(uplodateLoading(false));
            if (response.status === '200') {
                setVideos(response?.data?.items)
            } else {
                showDangerToast(response.message);
            }
        } catch (error) {
            dispatch(uplodateLoading(false));
            console.error(error);
            showDangerToast(error.message);
        }
    }

    const handleCardClick = (video, event) => {
        let id = video?.id;
        let price = props?.eventDetails?.basePrice;
        let userId = video?.userId;
        if (event.ctrlKey || event.metaKey) {
            // Multi-selection
            setSelectedIds((prev) => {
                const exists = prev.some((item) => item.id === video?.id);
                const localSelectedIds = exists
                    ? prev.filter((item) => item.id !== video?.id)
                    : [...prev, { id: video?.id, userId: video?.userId, price: price }];
                return localSelectedIds;
            });
        } else {
            // Single selection
            setSelectedIds((prev) => {
                const exists = prev.some((item) => item.id === video?.id);
                const localSelectedIds = exists ? [] : [{ id: video?.id, userId: video?.userId, price: price }];
                return localSelectedIds;
            });
        }

    };

    const handleGiveReward = async () => {
        try {
            // Prepare the JSON data to be sent in the POST request
            let postJson = {
                videos: selectedIds
            };
            // Set loading state
            dispatch(uplodateLoading(true));

            // Define the API path
            let path = urls.giveRewardToEventVideos + '/' + props?.id;

            // Make the POST request
            var res = await ApiCaller.post(postJson, path, userData?.access_token);
            // Handle the response
            const response = await res.response.json();
            dispatch(uplodateLoading(false));
            if (response.status === '200') {
                showToast(response?.message)
                setSelectedIds([])
            } else {
                showDangerToast(response.message);
            }
        } catch (error) {
            dispatch(uplodateLoading(false));
            console.error(error);
            showDangerToast(error.message);
        }
    }

    const handleGiveRewardWithTransfer = async () => {

    }

    return (
        <div>
            <Typography variant="h6" align="center">Event Submission Videos</Typography>
            {selectedIds?.length > 0 && <AppBar position="static" color="default" elevation={1} sx={{ borderRadius: 2 }}>
                <Toolbar variant="dense" sx={{ minHeight: 48, px: 2 }}>
                    <IconButton edge="start" color="inherit" aria-label="close" onClick={() => setSelectedIds([])}>
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                        {selectedIds?.length} selected
                    </Typography>
                    <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
                    <Button variant="contained" endIcon={<EmojiEventsIcon />} onClick={() => handleGiveReward()}>
                        Give Reward
                    </Button>
                    <Button style={{ marginLeft: '10px' }} variant="contained" endIcon={<EmojiEventsIcon />} onClick={() => handleGiveRewardWithTransfer()}>
                        Give Rewrd and Transfer to Promo
                    </Button>
                    {/* <IconButton color="inherit" aria-label="download">
                          <DownloadIcon />
                        </IconButton>
                        <IconButton color="inherit" aria-label="image">
                          <ImageIcon />
                        </IconButton>
                        <IconButton color="inherit" aria-label="delete">
                          <DeleteIcon />
                        </IconButton>
                        <IconButton color="inherit" aria-label="link">
                          <LinkIcon />
                        </IconButton>
                        <IconButton
                          color="inherit"
                          aria-label="more"
                          id="long-button"
                          aria-controls={open ? 'long-menu' : undefined}
                          aria-expanded={open ? 'true' : undefined}
                          aria-haspopup="true"
                          onClick={handleClick}
                        >
                          <MoreHorizIcon />
                        </IconButton>
                        <Menu
                          id="long-menu"
                          MenuListProps={{
                            'aria-labelledby': 'long-button',
                          }}
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                        >
                          <MenuItem onClick={handleClose}>Copy</MenuItem>
                          <MenuItem onClick={handleClose}>Move</MenuItem>
                          <MenuItem onClick={handleClose}>Rename</MenuItem>
                        </Menu> */}
                </Toolbar>
            </AppBar>}
            {videos?.length > 0 ?
                <div style={{ width: '100%', overflow: 'hidden', padding: '10px' }}>
                    <Grid container spacing={3} alignItems="flex-start" justifyContent="flex-start">
                        {videos.map((video, index) => (
                            <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
                                <VideoCard
                                    {...video}
                                    eventDetails={props?.eventDetails}
                                    eventId={props?.id}
                                    postions={props?.criteria}
                                    onClick={(e) => handleCardClick(video, e)}
                                    handlePlay={props?.handlePlayVideo}
                                    handlePause={props?.handlePauseVideo}
                                    style={{
                                        border: selectedIds.some((item) => item.id === video?.id) ? "2px solid blue" : "1px solid gray",
                                        padding: "16px",
                                        cursor: "pointer",
                                        borderRadius: "8px",
                                    }}
                                    handleTransferToPromoModalOpen={(link) => handleTransferToPromoModalOpen(link)}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </div> : <>
                    <div className='text-center'>
                        <img width={'25%'} src={NoDataImg}></img>
                        <br />
                        <label style={{ fontWeight: 'bold' }}>
                            {LOADING_ENABLE ? (
                                <>Loading Data.....</>
                            ) : (
                                <>No Submission Received Yet.</>
                            )}
                        </label>
                    </div>
                </>}
            <TransferToPromoModal
                show={showTransferToPromoModal}
                link={transferVideoLink}
                onSubmit={() => {
                    setShowTransferToPromoModal(false)
                    setTransferVideoLink('')
                }}
                onHide={() => setShowTransferToPromoModal(false)}
            />
        </div>
    );
};